﻿import UserSetupPage from "./userSetupPage";

if (!window.userSetupPage) {
    window.userSetupPage = new UserSetupPage();
}
